<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    v-if="dialog"
  >
    <popup-header @clickClose="closeModal()" />

    <select-date-header />
    <select-date-title :dateTitle="'날짜선택'" />
    <select-date-content @selectDate="selectDate" />
  </v-dialog>
</template>

<script>
import PopupHeader from '@/components/common/PopupHeader.vue'; // dialog Header component
import SelectDateHeader from '@/components/application/form/SelectDateHeader.vue';
import SelectDateContent from '@/components/application/form/SelectDateContent.vue';
import SelectDateTitle from '@/components/application/form/SelectDateTitle.vue';
import dialogMixin from '@/mixins/dialogMixin.js';
import dayjs from 'dayjs';

export default {
  mixins: [dialogMixin],
  data: () => ({
    modalName: 'select_annual_plan_date',
  }),
  methods: {
    selectDate(date) {
      this.$emit('selectDate', dayjs(date).format('YYYY-MM-DD'));
      this.closeModal();
    },
  },
  components: {
    PopupHeader,
    SelectDateHeader,
    SelectDateContent,
    SelectDateTitle,
  },
};
</script>

<style></style>
